import { computed, inject, Injectable } from '@angular/core';

import {
    MapBaseSource,
    MapFieldInterventionSource,
    MapLayerSource,
} from '@connect-services/client/components/map/map.component';
import { MapDrawService } from '@connect-services/client/services/map-draw.service';
import { MapSourceService } from '@connect-services/client/services/map-source.service';
import { SourcesService } from '@connect-services/client/services/sources.service';

@Injectable({ providedIn: 'root' })
export class SourcesActivationService {
    public readonly activated = computed<Record<string, boolean>>(() => {
        MapSourceService.checkSourcesZoom();
        MapSourceService.checkSourcesVisibility();

        const map: Record<string, boolean> = {};

        this.sourcesService.sources().forEach((source: MapBaseSource<unknown>) => {
            if (source instanceof MapLayerSource) {
                map[source.sourceId] = this.mapDrawService.setIsActivated(source);
            } else if (source instanceof MapFieldInterventionSource) {
                map[source.sourceId] = true;
            }
        });

        return map;
    });

    private readonly mapDrawService = inject(MapDrawService);
    private readonly sourcesService = inject(SourcesService);

    public get(sourceId: string): boolean {
        return this.activated()[sourceId];
    }
}
